import { standardApiHandler } from "../../../core/core-api/apiTools";
import { wfsBlobServiceAdapter } from "./wfsBlobService.adapter";
import { ApiWfsServiceResponse } from "../wfs-service/types";

export type WfsBlobServiceServiceParams = {
    typeName?: string | string[];
    ENV?: string;
    startIndex?: number;
    count?: number;
    resultType?: string;
    CQL_FILTER?: string;
    featureId?: number;
    srsName?: string;
    wizardSuiteProperties?: boolean;
    bbox?: string;
    outputFormat?: string;
};

export type WfsBlobServiceService = (params: WfsBlobServiceServiceParams) => Promise<ApiWfsServiceResponse | string>;
export const wfsBlobService: WfsBlobServiceService = standardApiHandler(wfsBlobServiceAdapter);
